<template>
  <div v-if="this.$store.getters['authorization/acl'].hasPermission('sms_access')"
       class="PlatformSms"
  >
    <ShPageHeader :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'Wysyłanie i odbieranie wiadomości SMS', path: '/sms' }
                  ]"
                  description="Zakładka pozwala na wysyłkę i odbieranie wiadomości SMS oraz wyświetlanie historii wiadomości."
                  title="Wysyłanie i odbieranie wiadomości SMS"
    />
    <ShPageLayout>
      <CustomTabs active-tab="sms_gateway"
                  :tabs="[
                    { name: 'sms_gateway', label: 'Bramka SMS', isVisible: true },
                    { name: 'sms_queue', label: 'Kolejka SMS', isVisible: true },
                    { name: 'sms_history', label: 'Historia SMS', isVisible: this.$store.getters['authorization/acl'].hasPermission('sms_history_access')},
                    { name: 'sms_templates', label: 'Szablony SMS', isVisible: this.$store.getters['authorization/acl'].hasPermission('sms_templates_access')},
                    { name: 'sms_incoming', label: 'SMS przychodzące', isVisible: this.$store.getters['authorization/acl'].hasPermission('sms_incoming_access')},
                  ]"
      >
        <template #sms_gateway>
          <el-row :gutter="20">
            <el-col :span="12">
              <SmsGateway :projects-list="projectsList"
                          :user-data="userData" />
            </el-col>
            <el-col v-if="true"
                    :span="12"
            >
              <SmsQueue :projects-list="projectsList"
                        :content-size="'smallTable'" />
            </el-col>
          </el-row>
        </template>
        <template #sms_queue>
          <SmsQueue :projects-list="projectsList"
                    :content-size="'bigTable'" />
        </template>
        <template #sms_history>
          <SmsHistory :projects-list="projectsList" />
        </template>
        <template #sms_templates>
          <SmsTemplates :projects-list="projectsList" />
        </template>
        <template #sms_incoming>
          <SmsIncoming :projects-list="projectsList" />
        </template>
      </CustomTabs>
    </ShPageLayout>
  </div>
</template>

<script>

import CustomTabs from '../components/Common/CustomTabs';
import SmsGateway from '../components/Sms/SmsGateway';
import SmsQueue from '../components/Sms/SmsQueue';
import SmsHistory from '../components/Sms/SmsHistory';
import SmsTemplates from '../components/Sms/SmsTemplates';
import SmsIncoming from '../components/Sms/SmsIncoming';

export default {
  name: 'PlatformSms',
  components: {
    CustomTabs,
    SmsGateway,
    SmsQueue,
    SmsHistory,
    SmsTemplates,
    SmsIncoming,
  },

  data() {
    return {
    };
  },

  computed: {
    projectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    userData() {
      return this.$store.getters['authorization/user'];
    },
    statusList() {
      return this.$store.getters['sms/statusList'];
    },
    typeList() {
      return this.$store.getters['sms/typeList'];
    },
  },

  async created() {
    await this.$store.dispatch('client/projects/getList', this.userData.client.client_uuid);
    await this.$store.dispatch('sms/getStatusAndTypeDictionary');
  },

  methods: {
  },

};
</script>

<style lang="sass" scoped>
.PlatformSms
</style>
